export const SECTION_KEYS = {
  DASHBOARD: 'dashboard',
  EXTENDED_DASHBOARD: 'extended-dashboard',
  WEEKLY_DASHBOARD: 'weekly-dashboard',
  METAS_DASHBOARD: 'metas-dashboard',
  SURVEYS: 'surveys',
  SURVEY_STATS: 'survey-stats',
  CLIENT_ACCOUNTS: 'client-accounts',
  //SURVEYS_BUILDER: 'surveys-builder',
  ALERTS: 'alerts',
  CO_CREATION: 'co-creation',
  SOCIAL_LISTENING: 'social-listening',
  ACTION_PLANS: 'action-plans',
  REPORTS: 'reports',
  DASHBOARDAI: 'dashboard-ai',
  OMOIKANE_AI: 'omoikane-ai',
  POWER_INTELLIGENCE: 'power-intelligence',
  AGENT: 'agent',

  LOGICAL_DISTRIBUTIONS: 'logical-distributions',
  GEOGRAPHIC_DISTRIBUTIONS: 'geo-distributions',
  CRITICAL_MOMENTS: 'critical-moments',
  CHANNELS: 'channels',
  CATEGORIES: 'sentiment-category',
  CHANGE_PASSWORD: 'change-password',
  USERS_HIERARCHY: 'users-hierarchy',
  CHAT_ASSISTANT: 'chat-assistant'
}

export const SECTION_ACTIONS = {
  [SECTION_KEYS.DASHBOARD]: { label: 'perms.main', value: 'main' },
  [SECTION_KEYS.EXTENDED_DASHBOARD]: { label: 'perms.main', value: 'main' },
  [SECTION_KEYS.METAS_DASHBOARD]: { label: 'perms.main', value: 'main' },
  [SECTION_KEYS.WEEKLY_DASHBOARD]: { label: 'perms.main', value: 'main' },
  [SECTION_KEYS.OMOIKANE_AI]: { label: 'perms.main', value: 'main' },
  [SECTION_KEYS.POWER_INTELLIGENCE]: { label: 'perms.main', value: 'main' },
  [SECTION_KEYS.SURVEYS]: [
    { label: 'perms.main', value: 'main' },
    { label: 'perms.wizard', value: 'wizard' },
    { label: 'perms.admin', value: 'update' },
    { label: 'perms.delete', value: 'delete' },
  ],
  [SECTION_KEYS.SURVEY_STATS]: [
    { label: 'perms.main', value: 'main' }
  ],
  [SECTION_KEYS.CLIENT_ACCOUNTS]: [
    { label: 'perms.main', value: 'main' }
  ],
  [SECTION_KEYS.SOCIAL_LISTENING]: { label: 'perms.main', value: 'main' },
  [SECTION_KEYS.ALERTS]: [
    { label: 'perms.main', value: 'main' },
    { label: 'perms.stats', value: 'stats' },
    { label: 'perms.detail', value: 'detail' },
    { label: 'perms.close', value: 'update' },
    { label: 'perms.addComment', value: 'addComment' },
    { label: 'perms.addEvidence', value: 'addEvidence' },
    { label: 'perms.notifications', value: 'notifications' },
    { label: 'perms.reOpenAlert', value: 'reOpen' },
  ],
  [SECTION_KEYS.CO_CREATION]: { label: 'perms.main', value: 'main' },
  [SECTION_KEYS.ACTION_PLANS]: [
    { label: 'perms.main', value: 'main' },
    { label: 'perms.create', value: 'create' },
    { label: 'perms.add-activity', value: 'add-activity' },
    { label: 'perms.admin', value: 'update' },
    { label: 'perms.close', value: 'close' },
    { label: 'perms.root-cause', value: 'root-cause' },
    { label: 'perms.delete', value: 'delete' },
  ],

  [SECTION_KEYS.REPORTS]: { label: 'perms.main', value: 'main' },
  [SECTION_KEYS.CHAT_ASSISTANT]: { label: 'perms.main', value: 'main' },
  [SECTION_KEYS.AGENT]: { label: 'perms.main', value: 'main' },
}
